import { useEffect, useState } from 'react';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Tabs, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import { toDateTimeLocal } from '../../../shared/lib/datetime-local';
import { defaultScheduleAt } from '../lib/publishPlan';

/**
 * Шаг «Когда публикуем» — один и тот же у рилса и поста (02.11.2026). Раньше
 * у рилса было «Отложенная публикация» с кнопкой «Сейчас», у поста — «Отложить
 * публикацию» с крестиком, и в том же шаге жили тип контента и сторис.
 *
 * value — строка datetime-local; пусто = публикуем сразу.
 */
export function WhenToPublish({ value, onChange, id = 'scheduled-at' }: {
  value: string;
  onChange: (value: string) => void;
  id?: string;
}) {
  // Режим следует за значением: форма сбросила время после публикации — снова
  // «Сейчас». «Запланировать» сразу ставит время по умолчанию, так что пустое
  // поле в этом режиме бывает только если его стёрли руками.
  const [later, setLater] = useState(!!value);
  useEffect(() => { setLater(!!value); }, [value]);
  const min = toDateTimeLocal(new Date(Date.now() + 60_000));

  return (
    <div className="space-y-2">
      <Tabs
        value={later ? 'later' : 'now'}
        onValueChange={(v) => {
          if (v === 'now') { setLater(false); onChange(''); return; }
          setLater(true);
          if (!value) onChange(toDateTimeLocal(defaultScheduleAt(new Date())));
        }}
      >
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="now">Сейчас</TabsTrigger>
          <TabsTrigger value="later">Запланировать</TabsTrigger>
        </TabsList>
      </Tabs>
      {later && (
        <div className="space-y-1">
          <Label htmlFor={id}>Дата и время</Label>
          <Input id={id} type="datetime-local" value={value} min={min} onChange={(e) => onChange(e.target.value)} />
        </div>
      )}
      <p className="text-xs text-muted-foreground">
        {later
          ? 'Медиа подготовим сразу, в ленту публикация уйдёт в указанное время. Очередь — «Публикации → Отложенные».'
          : 'Публикуем сразу после подтверждения.'}
      </p>
    </div>
  );
}
